import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getRecordStatus } from '../utils/getRecordStatus';

export const useGetRecord = (contentInfo, generalInfo) => {
  const [hasBeenRecord, setHasBeenRecord] = useState(false);
  const [recordingStatus, setRecordingStatus] = useState('');
  const [recordingStatusIcon, setRecordingStatusIcon] = useState('');
  const [eventRecorded, setEventRecorded] = useState('');

  const epgChannels = useSelector(state => state.Player.EpgChannels.data);
  const recordingList = useSelector(
    state => state.Player.Recording.Recording?.data?.recordings,
  );
  const seriesList = useSelector(
    state => state.Player.Recording.RecordingSeriesList?.data,
  );
  const generalEventAlfId =
    contentInfo?.event_alf_id || generalInfo?.event_alf_id;
  const isRecordingList = recordingList?.length > 0 ? true : false;

  //Buscar el evento y estatus de una grabacion desde le EPG
  useEffect(
    () => {
      if (!epgChannels) return;

      const findChannel = epgChannels?.find(
        channelItem =>
          channelItem?.group_id === contentInfo?.id ||
          contentInfo?.channel_group_id,
      );
      const findEvent = findChannel?.events?.find(
        eventItem =>
          eventItem?.id === contentInfo?.actual_event?.id || contentInfo?.id,
      );
      const hasRecord = recordingList?.find(
        recordItem =>
          recordItem?.channel?.event?.event_alf_id === generalEventAlfId,
      );

      const hasRecordSerie = seriesList?.find(
        recordItem =>
          recordItem?.channel?.event?.event_alf_id === generalEventAlfId,
      );
      const hasRecordedSerieOrEpisode = hasRecord || hasRecordSerie;
      const { recordStatusIcon, recordStatus } = getRecordStatus(
        hasRecordedSerieOrEpisode,
      );

      setHasBeenRecord(hasRecordedSerieOrEpisode ? true : false);
      setRecordingStatus(recordStatus);
      setRecordingStatusIcon(recordStatusIcon);
      setEventRecorded(hasRecordedSerieOrEpisode);
    },
    [isRecordingList],
  );

  return {
    recordingStatus,
    hasBeenRecord,
    recordingStatusIcon,
    eventRecorded,
  };
};
